import {ServiceGlobal} from './service.global';
import {Injectable} from '@angular/core';
import 'rxjs/add/operator/toPromise';
import {API} from '../../config/api';


@Injectable()
export class StudentQuestionnaireAnswerService extends ServiceGlobal {

    sequence: any;
    name_alpha: any = 'text_en';
    api_find_all: any = 'student_questionnaire_answers';
    loading: any = false;
    primary_key: any = 'student_questionnaire_answer_id';
    tableName() { return 'student_questionnaire_answers'; }

    attributeLabels() {
        return Object.assign(super.attributeLabels(), {
            "student_questionnaire_answer_id": "Student Questionnaire Answer",
            "createddate": "Date Created",
            "lastmoddate": "Date Last Modified",
            "created_by": "Created By",
            "modified_by": "Modified By",
            "student_questionnaire": "Student Questionnaire",
            "student_questionnaire_question": "Student Questionnaire Question",
            "answer": "Answer"
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/common/services/student-questionnaire-answer.service.ts